import axios from 'axios';

const baseURL = process.env.NODE_ENV === 'production'
  ? '' // <- empty string makes axios use relative paths like /api/catalogs
  : 'http://localhost:3001';

const axiosInstance = axios.create({
  baseURL,
  withCredentials: true,
});


axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
